module.exports = __webpack_public_path__ + "img/03.0eb56c51.png";